import { translate } from '@jsverse/transloco';
export interface TaskReview {
    event: TaskReviewEvent;
    action: TaskReviewAction;
    count: number;
    notes: string;
    createdOn: Date;
    createdBy: string;
}

export enum TaskReviewEvent {
    ORIGINAL_REVIEWS = 'ORIGINAL_REVIEWS',
    MODIFIED_REVIEWS = 'MODIFIED_REVIEWS',
}

export interface TaskReviewRequest {
    action: TaskReviewAction;
    count: number;
    notes: string;
}

export enum TaskReviewAction {
    ADD_REVIEWS = 'ADD_REVIEWS',
    REMOVE_REVIEWS = 'REMOVE_REVIEWS',
}

export class TaskReviewHelper {
    static getTaskReviewEventLocale(event: TaskReviewEvent): string {
        switch (event) {
            case TaskReviewEvent.ORIGINAL_REVIEWS:
                return translate('TASK_TRACKER.ORIGINAL_REVIEWS');
            case TaskReviewEvent.MODIFIED_REVIEWS:
                return translate('TASK_TRACKER.MODIFIED_REVIEWS');
            default:
                return event + '';
        }
    }

    static renderNegativeCount(value: TaskReview): string {
        return (value.action === TaskReviewAction.REMOVE_REVIEWS ? value.count * -1 : value.count) + '';
    }
}
